import React, { MouseEvent } from 'react';
import SvgIcon from 'src/react_components/svg-icon';

type EditableCommentFooterProps = {
  isCommentFlagged: boolean,
  isEditingDisabled: boolean,
  hasSources: boolean,
  commentBlank: boolean,
  removeClick: (e: MouseEvent) => void,
  removeCitationClick: (e: MouseEvent) => void,
  editClick: (e: MouseEvent) => void
}

const EditableCommentFooter: React.FC<EditableCommentFooterProps> = ({
  isCommentFlagged,
  isEditingDisabled,
  hasSources,
  removeClick,
  removeCitationClick,
  commentBlank,
  editClick
}) => {
  const removeAnnotationButton = (
    <button
      type="button"
      className="btn-link text-larger remove-annotation"
      onClick={removeClick}
      disabled={isEditingDisabled}
      aria-label="remove annotation"
    >
      <SvgIcon
        className="icon-sm valign-middle icon-delete"
        icon="delete"
      />
    </button>
  );

  const removeCitationButton = (
    <button
      type="button"
      className="btn-link remove-citation text-larger remove-annotation"
      onClick={removeCitationClick}
      disabled={isEditingDisabled}
      aria-label="remove citation"
    >
      <SvgIcon
        className="icon-sm valign-middle icon-delete"
        icon="delete"
      />
    </button>
  );

  const editButton = () => (
    <button
      type="button"
      className="btn-link"
      onClick={editClick}
      disabled={isEditingDisabled}
    >
      {commentBlank ? 'Add a comment' : 'Edit'}
    </button>
  );

  return (
    <div className="panel-footer">
      {editButton() || <div />}
      <div className="d-flex">
        {hasSources ? removeCitationButton : removeAnnotationButton}
        {isCommentFlagged && (
          <SvgIcon
            className="icon-md orange valign-middle pull-right-lg icon-warning"
            icon="warning"
          />
        )}
      </div>
    </div>
  );
};

export default EditableCommentFooter;
